<div class="card border-0 shadow-sm pt-0 pb-1 mb-4">
    <div class="card-header fs-5 fw-medium">Financial Details</div>
    <div class="card-body position-relative">
        <dx-load-panel [visible]="isLoading" [showPane]="false" [position]="{ of: '.card-body' }"></dx-load-panel>
        @if(financialData) {
            <div class="px-3 mb-4">
                <div class="row g-3">
                    <div class="col-md-4">
                        <employment-detail-row label="Standard Hours"
                                               [value]="financialData.standardHours"></employment-detail-row>
                    </div>
                    <div class="col-md-4">
                        <employment-detail-row label="Pay Rate Code"
                                               [value]="financialData.regularPayRateCode"></employment-detail-row>
                    </div>
                    <div class="col-md-4">
                        <employment-detail-row label="Pay Rate Amount"
                                               [value]="financialData.payRateAmount"></employment-detail-row>
                    </div>
                </div>
            </div>
        }
    </div>
</div>

